import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  NavigationUIMenuKeys,
  NavLinksComponent,
  PrimaryNavActionEvent,
  SecondaryNavActionEvent
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AdobeDataLayerService,
  AnalyticsService,
  ApplicationConfig,
  HEADER_TOP_MENU
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { NavigationLinksFacadeService } from '../../../data-access/facades/navigation-links/navigation-links-facade.service';
import { SecondaryNavigationLinksFacadeService } from '../../../data-access/facades/secondary-navigation-links/secondary-navigation-links-facade.service';

@Component({
  selector: 'idp-navigation-links',
  standalone: true,
  imports: [CommonModule, PushPipe, NavLinksComponent],
  templateUrl: './navigation-links.component.html',
  styleUrls: ['./navigation-links.component.scss']
})
export class NavigationLinksComponent implements OnInit {
  @Input() isMobile = false;
  @Input() selectedNav!: string;
  @Input() selectedSecondaryNav!: string;
  @Input() APP_DISABLE_LEGACY = true;
  @Input() isLoggedIn = false;
  @Input() isBusinessAccount = false;
  @Output() primaryNavActionEvent = new EventEmitter<PrimaryNavActionEvent>();
  @Output() secondaryNavActionEvent =
    new EventEmitter<SecondaryNavActionEvent>();

  facade = inject(NavigationLinksFacadeService);
  secondaryFacade = inject(SecondaryNavigationLinksFacadeService);
  adobeAnalytics = inject(AdobeDataLayerService);
  analytics = inject(AnalyticsService);
  appConfig = inject(ApplicationConfig);

  onClickOutside(): void {
    if (!this.APP_DISABLE_LEGACY) {
      this.primaryNavActionEvent.emit({ id: '' });
    }
  }

  ngOnInit(): void {
    this.facade.init();
  }

  emitAdobeAnalytics(e: { id: NavigationUIMenuKeys; label?: string }): void {
    const menus: Record<
      NavigationUIMenuKeys,
      (typeof HEADER_TOP_MENU)[keyof typeof HEADER_TOP_MENU]
    > = {
      book: HEADER_TOP_MENU.BOOK,
      check_in: HEADER_TOP_MENU.CHECK_IN,
      my_trips: HEADER_TOP_MENU.MY_TRIPS,
      flightstatus: HEADER_TOP_MENU.FLIGHT_STATUS,
      secondarynav: HEADER_TOP_MENU.TRAVEL_INFO,
      'sky-miles': HEADER_TOP_MENU.SKYMILES,
      more: HEADER_TOP_MENU.NEED_HELP
    };
    const id = e?.label?.toLowerCase()?.replace('?', '') || e.id;
    this.adobeAnalytics.updateAnalytics(id, menus[e?.id]);
  }

  primaryNavSelected(value: PrimaryNavActionEvent): void {
    const hasAdvanceSearch = !!document.querySelector('idp-advance-search');
    if (hasAdvanceSearch && value.id === 'book') {
      this.primaryNavActionEvent.emit({ id: '' });
      window.location.reload();
    } else {
      this.primaryNavActionEvent.emit(value);
    }
  }
}
